import * as React from 'react';
import BottomNavigation from '@mui/material/BottomNavigation';
import BottomNavigationAction from '@mui/material/BottomNavigationAction';
import FolderIcon from '@mui/icons-material/Folder';
import RestoreIcon from '@mui/icons-material/Restore';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LocationOnIcon from '@mui/icons-material/LocationOn';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/BottomNavigation": BottomNavigation, "@mui/material/BottomNavigationAction": BottomNavigationAction, "@mui/icons-material/Folder": FolderIcon, "@mui/icons-material/Restore": RestoreIcon, "@mui/icons-material/Favorite": FavoriteIcon, "@mui/icons-material/LocationOn": LocationOnIcon } } });
export default ClientProvider;
